import { AnyObject, MixedSchema } from '@framework/validation';

/**
 * Ritorna vero se lo schema indica come "modificabile" il campo
 * (attraverso il meta della funzione custom yup.enabled())
 */
export function isFieldEnabled(
  schema: Array<MixedSchema<any, AnyObject, undefined, ''>>,
) {
  return !schema.some(s => s?.meta()?.enabled === false);
}

/**
 * Ritorna vero se lo schema indica come "modificabile" il campo
 * (attraverso il meta della funzione custom yup.enabled())
 * A differenza della isFieldEnabled, questo flag indica una disabilitazione solo
 * a livello UX/UI e non ha un impatto logico sullo schema o sulla validazione
 * (ovvero, il campo non è modificabile da interfaccia, ma per la validazione il flag
 * non ha effetto.
 * In questo modo è possibile disabilitare un campo _senza_ richiederne il reset del valore)
 */
export function isFieldLayoutEnabled(
  schema: Array<MixedSchema<any, AnyObject, undefined, ''>>,
) {
  return !schema.some(s => s?.meta()?.layoutEnabled === false);
}
